import { useEffect, useState } from 'react';
import { getTimeToNextSundayMSK } from '../utils/date/getTimeToNextSundayMSK';

export function useCountdownToSundayMSK(updateIntervalMs = 60_000) {
  const [state, setState] = useState({
    endDayMSK: null,
    diffTime: null,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const update = () => setState(getTimeToNextSundayMSK());
    update();
    const id = setInterval(update, updateIntervalMs);
    return () => clearInterval(id);
  }, [updateIntervalMs]);

  return state;
}
